import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Product from "../pages/product/page";
import Checkout from "../pages/checkout/page";
import CheckoutPost from "../pages/checkout/post";     // 補齊：金流過場頁
import CheckoutResult from "../pages/checkout/result"; // 補齊：金流結果頁
import Login from "../pages/login/page";
import Member from "../pages/member/page";
import KeyInfo from "../pages/key-info/page";
import Layout from "../components/feature/Layout";
// 新增引入我們寫好的 ProtectedRoute 路由守衛元件
import { ProtectedRoute } from "../components/ProtectedRoute";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/product/:id",
        element: <Product />,
      },
      {
        path: "/checkout",
        // 核心修正：使用 ProtectedRoute 包覆需要登入權限的頁面
        element: (
          <ProtectedRoute>
            <Checkout />
          </ProtectedRoute>
        ),
      },
      {
        path: "/checkout/post",
        // 金流自動跳轉過場頁面 (需登入)
        element: (
          <ProtectedRoute>
            <CheckoutPost />
          </ProtectedRoute>
        ),
      },
      {
        path: "/checkout/result",
        // 金流完成後的結果查詢頁面 (需登入)
        element: (
          <ProtectedRoute>
            <CheckoutResult />
          </ProtectedRoute>
        ),
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/member",
        // 核心修正：使用 ProtectedRoute 包覆需要登入權限的頁面
        element: (
          <ProtectedRoute>
            <Member />
          </ProtectedRoute>
        ),
      },
      {
        path: "/key-info",
        // 核心修正：使用 ProtectedRoute 包覆需要登入權限的頁面
        element: (
          <ProtectedRoute>
            <KeyInfo />
          </ProtectedRoute>
        ),
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;